"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchableInputAdapter = exports.DropdownAdapter = exports.ActionInputAdapter = exports.SwitchAdapter = exports.RadiosAdapter = exports.CheckboxAdapter = exports.TextAreaAdaper = exports.TextInputAdapter = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _text = _interopRequireDefault(require("../../../atoms/text"));

var _textInput = _interopRequireDefault(require("../../../atoms/text-input"));

var _textarea = _interopRequireDefault(require("../../../atoms/textarea"));

var _checkbox = _interopRequireDefault(require("../../../atoms/checkbox"));

var _radio = _interopRequireDefault(require("../../../atoms/radio"));

var _switch = _interopRequireDefault(require("../../../atoms/switch"));

var _actionInput = _interopRequireDefault(require("../../action-input"));

var _dropdown = _interopRequireDefault(require("../../dropdown"));

var _searchableInput = _interopRequireDefault(require("../../searchable-input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 32px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var MarginedDiv = _styledComponents["default"].div(_templateObject());

var ErrorDiv = _styledComponents["default"].div(_templateObject2());

var errorText = function errorText(_ref) {
  var touched = _ref.touched,
      error = _ref.error;
  return touched ? error ? _react["default"].createElement(ErrorDiv, null, _react["default"].createElement(_text["default"], {
    color: "vermilion",
    size: 6
  }, error)) : null : null;
};

var TextInputAdapter = function TextInputAdapter(_ref2) {
  var input = _ref2.input,
      _ref2$meta = _ref2.meta,
      touched = _ref2$meta.touched,
      error = _ref2$meta.error,
      rest = _objectWithoutProperties(_ref2, ["input", "meta"]);

  return _react["default"].createElement(_textInput["default"], _extends({}, input, {
    error: touched ? error : null
  }, rest));
};

exports.TextInputAdapter = TextInputAdapter;

var TextAreaAdaper = function TextAreaAdaper(_ref3) {
  var input = _ref3.input,
      _ref3$meta = _ref3.meta,
      touched = _ref3$meta.touched,
      error = _ref3$meta.error,
      rest = _objectWithoutProperties(_ref3, ["input", "meta"]);

  return _react["default"].createElement(_textarea["default"], _extends({}, input, {
    error: touched ? error : null
  }, rest));
};

exports.TextAreaAdaper = TextAreaAdaper;

var ActionInputAdapter = function ActionInputAdapter(_ref4) {
  var input = _ref4.input,
      _ref4$meta = _ref4.meta,
      touched = _ref4$meta.touched,
      error = _ref4$meta.error,
      rest = _objectWithoutProperties(_ref4, ["input", "meta"]);

  return _react["default"].createElement(_actionInput["default"], _extends({}, input, {
    error: touched ? error : null
  }, rest));
};

exports.ActionInputAdapter = ActionInputAdapter;

var CheckboxAdapter = function CheckboxAdapter(_ref5) {
  var _ref5$input = _ref5.input,
      value = _ref5$input.value,
      onChange = _ref5$input.onChange,
      meta = _ref5.meta,
      rest = _objectWithoutProperties(_ref5, ["input", "meta"]);

  return _react["default"].createElement(MarginedDiv, null, _react["default"].createElement(_checkbox["default"], _extends({}, rest, {
    checked: !!value,
    onToggle: onChange
  })), errorText(meta));
};

exports.CheckboxAdapter = CheckboxAdapter;

var RadiosAdapter = function RadiosAdapter(_ref6) {
  var input = _ref6.input,
      meta = _ref6.meta,
      options = _ref6.options,
      rest = _objectWithoutProperties(_ref6, ["input", "meta", "options"]);

  return _react["default"].createElement(MarginedDiv, null, _react["default"].createElement(_radio["default"], _extends({
    key: input.value,
    onChange: input.onChange
  }, rest), options.map(function (_ref7) {
    var value = _ref7.value,
        label = _ref7.label,
        checked = _ref7.checked;
    return _react["default"].createElement(_radio["default"].Radio, {
      key: value,
      value: value,
      label: label,
      checked: value === input.value
    });
  })));
};

exports.RadiosAdapter = RadiosAdapter;

var SwitchAdapter = function SwitchAdapter(_ref8) {
  var _ref8$input = _ref8.input,
      value = _ref8$input.value,
      onChange = _ref8$input.onChange,
      meta = _ref8.meta,
      labels = _ref8.labels,
      on = _ref8.on,
      rest = _objectWithoutProperties(_ref8, ["input", "meta", "labels", "on"]);

  return _react["default"].createElement("div", null, _react["default"].createElement(_switch["default"], _extends({}, rest, {
    on: !!value,
    accessibleLabels: labels,
    onToggle: onChange
  })), errorText(meta));
};

exports.SwitchAdapter = SwitchAdapter;

var DropdownAdapter = function DropdownAdapter(_ref9) {
  var _ref9$input = _ref9.input,
      value = _ref9$input.value,
      onChange = _ref9$input.onChange,
      meta = _ref9.meta,
      options = _ref9.options,
      props = _objectWithoutProperties(_ref9, ["input", "meta", "options"]);

  return _react["default"].createElement(MarginedDiv, null, _react["default"].createElement(_dropdown["default"], _extends({}, props, {
    fullWidth: true,
    selected: value,
    onSelection: onChange
  }), options.map(function (_ref10) {
    var value = _ref10.value,
        label = _ref10.label;
    return _react["default"].createElement(_dropdown["default"].MenuItem, {
      key: value,
      value: value,
      label: label
    });
  })), errorText(meta));
};

exports.DropdownAdapter = DropdownAdapter;

var SearchableInputAdapter = function SearchableInputAdapter(_ref11) {
  var _ref11$input = _ref11.input,
      value = _ref11$input.value,
      onChange = _ref11$input.onChange,
      _ref11$meta = _ref11.meta,
      touched = _ref11$meta.touched,
      error = _ref11$meta.error,
      rest = _objectWithoutProperties(_ref11, ["input", "meta"]);

  return _react["default"].createElement(_searchableInput["default"], _extends({
    value: value,
    onSelection: onChange,
    error: touched ? error : null
  }, rest));
};

exports.SearchableInputAdapter = SearchableInputAdapter;